// extracted by mini-css-extract-plugin
export default {"card":"Card_card__U99wG","light":"Card_light__PM3GG","dark":"Card_dark__OaqYD"};